// extracted by mini-css-extract-plugin
export var active = "ScrollableGallery-module--active--0d12f";
export var boxContent = "ScrollableGallery-module--boxContent--6d2f6";
export var caret = "ScrollableGallery-module--caret--7bfe5";
export var caretContent = "ScrollableGallery-module--caretContent--130b7";
export var circle = "ScrollableGallery-module--circle--ad507";
export var container = "ScrollableGallery-module--container--455e3";
export var disable = "ScrollableGallery-module--disable--95829";